<template>
  <DxPopup @hidden="onHidden" :visible="showNoticeContentsPop" :show-close-button="true"
                      :show-title="true" :title="title" height="820" width="820" container=".v-application"
                      :resize-enabled="true" :shading="shading">
    <div style="height: 32px;">
      <i-card-vertical :headerTitle="title" />
    </div>

    <div style="height: calc(100% - 72px);" class="pa-2">
      <div class="h-full pa-2" style="border: 1px solid #cccccc;">
        <DxScrollView
          width="100%"
          height="100%"
          direction="both"
        >
          <div>
            <v-progress-circular
              :size="50"
              color="primary"
              :indeterminate="loading"
              v-if="loading"
            />
            <div v-if="!loading" v-html="content" />
          </div>
        </DxScrollView>
      </div>
    </div>
    <v-row>
      <!-- <v-col cols="3" v-if="visAcpt" >
           <div  style="height: 30px;" class="pt-2 d-flex justify-center align-center">
            <v-text-field class="popField" 
                                    dense 
                                    outlined 
                                    hide-details="auto"
                                    clearable 
                                    maxLength="5"
                                    v-model="makerCd"                               
                                  />
            <i-button :text="'Accept'" :isCustom="true" @click="btnAccept" class="ml-2" />
          </div>
      </v-col> -->
      <v-col cols="visAcpt === true ? 9 : 12">
           <div style="height: 30px;" class="pt-2 d-flex justify-center align-center">
            <v-checkbox v-model="openChk" label="Don't open this notice during 7 days." on-icon="mdi-check-circle-outline" off-icon="mdi-checkbox-blank-circle-outline" />
            <i-button :text="'Close'" :isCustom="true" @click="btnClose" class="ml-2" />
          </div>
      </v-col>
    </v-row>    
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="msgColor" bottom>
          {{ msg }}
    </v-snackbar>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import iCardVertical from '@/components/common/iCardVertical'
import iButton from '@/components/common/iButton'
import { DxScrollView } from 'devextreme-vue/scroll-view'
import { getContents } from '@/api/view/hycot/Z/admZ000'
import Cookies from 'js-cookie'
//import {acceptBulletin } from '@/api/common/login'

export default {
  name: 'noticeContentsPop',
  mixins: [baseview],
  components: {
    DxPopup,
    'i-card-vertical': iCardVertical,
    DxScrollView,
    iButton
  },
  props: {
    shading: {
      type: Boolean,
      default() {
        return true
      }
    },
    showNoticeContentsPop: {
      type: Boolean,
      default() {
        return false
      }
    },
    bulletinNo: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
  },
  data() {
     return {
       loading: false,
       content: '',
       openChk: false,
       makerCd: '',
       visAcpt: false,
       snackbar: false,
       msg: '',
       timeout: 2000,
       msgColor: ''
     }
  },
  watch: {
    'showNoticeContentsPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        } else {
          this.content = ''
        }
      },
      immediate: true
    }
  },

  methods: {
    init() {      
      this.getData()
      this.getOpenChk()
      // if ( this.bulletinNo === '2019090001' ) {
      //   this.visAcpt = true
      // }else {
      //   this.visAcpt = false
      // }
    },
    getOpenChk() {
      const isSaved = Cookies.get(`hycot_notice_${this.bulletinNo}`)

      if(isSaved) {
        this.openChk = true
      } else {
        this.openChk = false
      }
    },
    async getData() {
      console.log('noticeContentsPop', `/attachfile/hycot/notice/hycot_notice_${this.bulletinNo}.html`)
      this.loading = true
      await getContents(
        `/attachfile/hycot/notice/hycot_notice_${this.bulletinNo}.html`
      ).then(res => {
        console.log('res', res)

        this.content = res.body
      }).catch(err => {
        this.vToastify(this.$t('Failed to content download'), 'warn')
      }).finally(() => {
        this.loading = false
      })
    },
    onHidden(e) {
      this.btnClose()
    },
    btnClose() {
      if(this.openChk) {
        let expDt = new Date()
        expDt.setTime(expDt.getTime() + 1000 * 3600 * 24 * 7)
        Cookies.set(`hycot_notice_${this.bulletinNo}`, 'X', { expires: expDt, path: '' })
      } else {
        Cookies.remove(`hycot_notice_${this.bulletinNo}`)
      }
      
      this.$emit('update:showNoticeContentsPop', false)
      this.$emit('closePop')
    },
  //   async btnAccept() {

  //     if (!this.makerCd) {
  //        this.snackbar = true
  //       this.msg = 'Please input maker code!'
  //        return
  //     }

  //     let para = {
  //       userId : this.makerCd
  //     }

  //     await acceptBulletin(para).then((res) => { 
  //       console.log(res.body)
  //       if (res.body === 'Y') {
  //         this.snackbar = true
  //         this.msg = 'Successful Accept!'
  //         this.msgColor = 'success'
  //       } else if (res.body === 'A') {
  //         this.snackbar = true
  //         this.msg = 'This Maker already accept!'
  //         this.msgColor = 'error'
  //       } else if (res.body === 'N') {
  //         this.snackbar = true
  //         this.msg = 'This Maker ID not exists!'
  //         this.msgColor = 'error'
  //       } else if (res.body === 'N') {
  //         this.snackbar = true
  //         this.msg = 'Error'
  //         this.msgColor = 'error'
  //       }
  //     })
  //   }
   }
}
</script>

<style lang="scss" scoped>

</style>